import { useMemo, useState } from 'react';
import { useAppSelector } from '~/hooks/useAppSelector';
import { Autocomplete } from '../Autocomplete';
import { IOptionValue } from '../Autocomplete/interfaces';

interface IProps {
  placeholder?: string;
  value?: string;
  onChange: (value: IOptionValue<string> | undefined) => void;
  error?: boolean;
}

export const InputOfficeDropdown = ({ placeholder, onChange, value, error }: IProps) => {
  const [data, setData] = useState<IOptionValue<string>>();

  const offices = useAppSelector((state) => state.user.childOffices || []);

  const options = useMemo(
    () =>
      offices.map(
        (it) =>
          ({
            label: it.office_name,
            value: it.id,
          }) as IOptionValue<string>,
      ),
    [offices],
  );

  const handleOnChange = (value: IOptionValue) => {
    setData(value);
    onChange(value);
  };

  return (
    <Autocomplete
      maxSuggestions={5}
      options={options}
      placeholder={placeholder}
      value={value || data?.value}
      onChange={handleOnChange}
      error={error}
    />
  );
};
